import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { RequiredFieldsForParagraphOfParagraphsListFragmentDoc } from '../../../fragments/paragraphFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGetexParagraphIdsQueryVariables = Types.Exact<{
  getexRegulationId: Types.Scalars['ID'];
}>;


export type GetGetexParagraphIdsQuery = { __typename?: 'Query', exParagraphIds: Array<{ __typename?: 'InfinityGetexParagraphId', getexId: string, paragraphId: string }> };

export type GetGetexParagraphsNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsGetexParagraphsInput;
}>;


export type GetGetexParagraphsNextQuery = { __typename?: 'Query', exParagraphsNext: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', uri: any } | null }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null }> };

export type GetGetexParagraphsSortOrderQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsGetexParagraphsInput;
}>;


export type GetGetexParagraphsSortOrderQuery = { __typename?: 'Query', exParagraphsSortOrder: Array<{ __typename?: 'InfinityGetexParagraphId', getexId: string, paragraphId: string }> };

export type GetexRegulatoryDocumentParagraphInfinityFragment = { __typename?: 'RegulatoryDocumentParagraph', id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', uri: any } | null }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null };

export const GetexRegulatoryDocumentParagraphInfinityFragmentDoc = gql`
    fragment GetexRegulatoryDocumentParagraphInfinity on RegulatoryDocumentParagraph {
  ...RequiredFieldsForParagraphOfParagraphsList
}
    ${RequiredFieldsForParagraphOfParagraphsListFragmentDoc}`;
export const GetGetexParagraphIdsDocument = gql`
    query GetGetexParagraphIds($getexRegulationId: ID!) {
  exParagraphIds(getexRegulationId: $getexRegulationId) {
    getexId
    paragraphId
  }
}
    `;

/**
 * __useGetGetexParagraphIdsQuery__
 *
 * To run a query within a React component, call `useGetGetexParagraphIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetexParagraphIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetexParagraphIdsQuery({
 *   variables: {
 *      getexRegulationId: // value for 'getexRegulationId'
 *   },
 * });
 */
export function useGetGetexParagraphIdsQuery(baseOptions: Apollo.QueryHookOptions<GetGetexParagraphIdsQuery, GetGetexParagraphIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGetexParagraphIdsQuery, GetGetexParagraphIdsQueryVariables>(GetGetexParagraphIdsDocument, options);
      }
export function useGetGetexParagraphIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGetexParagraphIdsQuery, GetGetexParagraphIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGetexParagraphIdsQuery, GetGetexParagraphIdsQueryVariables>(GetGetexParagraphIdsDocument, options);
        }
export type GetGetexParagraphIdsQueryHookResult = ReturnType<typeof useGetGetexParagraphIdsQuery>;
export type GetGetexParagraphIdsLazyQueryHookResult = ReturnType<typeof useGetGetexParagraphIdsLazyQuery>;
export type GetGetexParagraphIdsQueryResult = Apollo.QueryResult<GetGetexParagraphIdsQuery, GetGetexParagraphIdsQueryVariables>;
export const GetGetexParagraphsNextDocument = gql`
    query GetGetexParagraphsNext($nextArgs: NextArgsGetexParagraphsInput!) {
  exParagraphsNext(nextArgs: $nextArgs) {
    ...GetexRegulatoryDocumentParagraphInfinity
  }
}
    ${GetexRegulatoryDocumentParagraphInfinityFragmentDoc}`;

/**
 * __useGetGetexParagraphsNextQuery__
 *
 * To run a query within a React component, call `useGetGetexParagraphsNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetexParagraphsNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetexParagraphsNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetGetexParagraphsNextQuery(baseOptions: Apollo.QueryHookOptions<GetGetexParagraphsNextQuery, GetGetexParagraphsNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGetexParagraphsNextQuery, GetGetexParagraphsNextQueryVariables>(GetGetexParagraphsNextDocument, options);
      }
export function useGetGetexParagraphsNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGetexParagraphsNextQuery, GetGetexParagraphsNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGetexParagraphsNextQuery, GetGetexParagraphsNextQueryVariables>(GetGetexParagraphsNextDocument, options);
        }
export type GetGetexParagraphsNextQueryHookResult = ReturnType<typeof useGetGetexParagraphsNextQuery>;
export type GetGetexParagraphsNextLazyQueryHookResult = ReturnType<typeof useGetGetexParagraphsNextLazyQuery>;
export type GetGetexParagraphsNextQueryResult = Apollo.QueryResult<GetGetexParagraphsNextQuery, GetGetexParagraphsNextQueryVariables>;
export const GetGetexParagraphsSortOrderDocument = gql`
    query GetGetexParagraphsSortOrder($sortArgs: SortArgsGetexParagraphsInput!) {
  exParagraphsSortOrder(sortArgs: $sortArgs) {
    getexId
    paragraphId
  }
}
    `;

/**
 * __useGetGetexParagraphsSortOrderQuery__
 *
 * To run a query within a React component, call `useGetGetexParagraphsSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetexParagraphsSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetexParagraphsSortOrderQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetGetexParagraphsSortOrderQuery(baseOptions: Apollo.QueryHookOptions<GetGetexParagraphsSortOrderQuery, GetGetexParagraphsSortOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGetexParagraphsSortOrderQuery, GetGetexParagraphsSortOrderQueryVariables>(GetGetexParagraphsSortOrderDocument, options);
      }
export function useGetGetexParagraphsSortOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGetexParagraphsSortOrderQuery, GetGetexParagraphsSortOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGetexParagraphsSortOrderQuery, GetGetexParagraphsSortOrderQueryVariables>(GetGetexParagraphsSortOrderDocument, options);
        }
export type GetGetexParagraphsSortOrderQueryHookResult = ReturnType<typeof useGetGetexParagraphsSortOrderQuery>;
export type GetGetexParagraphsSortOrderLazyQueryHookResult = ReturnType<typeof useGetGetexParagraphsSortOrderLazyQuery>;
export type GetGetexParagraphsSortOrderQueryResult = Apollo.QueryResult<GetGetexParagraphsSortOrderQuery, GetGetexParagraphsSortOrderQueryVariables>;